"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockOrganizationUid = void 0;
const utils_1 = require("../utils");
function mockOrganizationUid() {
    return `fake0org0${utils_1.weakRandomChars()}`;
}
exports.mockOrganizationUid = mockOrganizationUid;
//# sourceMappingURL=mock-organization-uid.js.map